import {  listSellerInfos, listSellerPaymentInfos } from "@/graphql/queries";
import { SellerInfo, SellerPaymentInfo } from "@/types/AppTypes";

import { createQueryOptions } from "../shared/createQueryOptions";


/// It will return array of items to get the seller info you have queried get the first item from the array item?.[0]

export const fetchSellerInfoQueryOptions = (filters: Record<string, any> = {}, options = {}) =>
  createQueryOptions<SellerInfo>({
    queryKey: ["seller_info", filters],
    graphqlQuery: listSellerInfos,
    getVariables: () => ({
      filter: {
        ...filters,
      },
    }),

    ...options,
  });


/// It will return array of items to get the seller payment methods you have queried get the first item from the array item?.[0]
export const fetchSellerPaymentMethodsQueryOptions = (
  filters: Record<string, any> = {},
  options = {}
) =>
  createQueryOptions<SellerPaymentInfo>({
    queryKey: ["seller_payment_methods", filters],
    graphqlQuery: listSellerPaymentInfos,
    getVariables: () => ({
      filter: {
        ...filters,
      },
    }),
    ...options,
  });
